import { CanDeactivate, Router } from "@angular/router";
import { ConfirmLeaveBacklogUnsyncedComponent } from "../confirm-leave-backlog-unsynced/confirm-leave-backlog-unsynced.component";
import { Observable } from "rxjs/Observable";
import { EpicsComponent } from "./epics.component";
import { EventEmitter } from "@angular/core";

export class EpicsConfirmDeactivateGuard
  implements CanDeactivate<EpicsComponent> {
  readonly result: EventEmitter<any> = new EventEmitter();

  constructor() {}

  canDeactivate(
    target: EpicsComponent,
    continueNavigation
  ): Observable<boolean> {
    if (!localStorage.getItem("stayUnsyncedNotification")) {
      return target.project && target.project.unsyncedChanges
        ? (<ConfirmLeaveBacklogUnsyncedComponent>(
            target.modalService.open(ConfirmLeaveBacklogUnsyncedComponent)
              .instance
          )).result.asObservable()
        : Observable.of(true);
    } else {
      return Observable.of(true);
    }
  }
}



// WEBPACK FOOTER //
// /agir/src/app/components/epics/confirm-deactivate.guard.ts